var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.281 4.118a36.837 36.837 0 0 1 15.437 0 2.507 2.507 0 0 1 1.982 2.45v9.937a2.507 2.507 0 0 1-1.982 2.45 36.835 36.835 0 0 1-15.437 0 2.507 2.507 0 0 1-1.981-2.45V6.569c0-1.182.826-2.204 1.981-2.451Zm15.144 1.369a35.437 35.437 0 0 0-14.85 0c-.51.109-.875.56-.875 1.082v9.936c0 .522.364.973.875 1.082a35.438 35.438 0 0 0 14.85 0c.51-.11.875-.56.875-1.082V6.569c0-.522-.365-.973-.875-1.082Zm-9.041 2.861a.7.7 0 0 1 .718.035l3.857 2.571a.7.7 0 0 1 0 1.165l-3.857 2.572a.7.7 0 0 1-1.088-.583V8.965a.7.7 0 0 1 .37-.617Zm1.03 1.925V12.8l1.895-1.263-1.895-1.264Z",
    fill: "currentColor"
  })));
};
export { SvgYoutube as ReactComponent };
export default __webpack_public_path__ + "73355e93d78e136c1509731a9c3fb0c7.svg";